

import { CustomHeading, CustomText } from "../../../../components/StyledComponents/styleComponents.index";

export const Cards = ({ actions, ctx }) => {

    const { gotoPage } = actions || {}
    const { value, cardLabel, iconLabel, imgIcon, labels } = ctx || {}

    return (
        <div style={{ 
            blockSize: "fit-content",
            backgroundColor: "#fff",
            borderRadius: "0.7rem", 
            border: '1px solid #999',
            inlineSize: "60%",
            padding: "1rem",
            display: 'flex', 
            gap: '12%',
            flexDirection: 'row', 
            alignItems: 'center', 
            justifyContent: 'space-around' }}>
            <section style={{ blockSize: "100%", display: 'flex', flexDirection: 'column', alignItems: 'center', inlineSize:"fit-content" }}>
                <img style={{ display: 'inline-block' }} src={imgIcon} alt="ícone de curto prazo" width={76} height={76}/>
                <CustomHeading 
                    color="mediumGrey" 
                    fontSize={["0.6rem", "1rem", "1.4rem"]} 
                    textAlign="center" 
                    style={{ lineHeight: 'normal'}}>
                    {iconLabel}
                </CustomHeading>

                <button 
                type="button" 
                onClick={() => gotoPage()}
                style={{ 
                    background: '#f26f21', 
                    border: '#f26f21', 
                    color: '#fff', 
                    cursor: 'pointer', 
                    fontSize: '1rem',
                    padding: "8px 20px",
                    fontWeight: 'bold',
                    borderRadius: '500px',
             }}>
                    {labels.btnLabel}
                </button>
            </section>

            <section style={{ blockSize: "100%", display: 'flex', flexDirection: 'column', alignItems: 'center', inlineSize:"fit-content" }}>
                <CustomHeading 
                    color="mediumGrey" 
                    fontSize={["0.6rem", "1rem", "1.4rem"]} 
                    inlineSize="90%" 
                    textAlign="center" 
                    style={{ lineHeight: 'normal' }}>
                    {cardLabel}
                </CustomHeading>

                <h3 style={{ color: "#374151", marginBlockStart: "0.8rem", fontSize: '2rem' }}>
                    {`${value}`}
                </h3>

                <CustomText color="mediumGrey" fontSize={['0.5rem', '0.875rem', '1rem']} textAlign="center" inlineSize="60%" >
                    {labels.cardText}
                </CustomText>
            </section>            
        </div>
    )
}